import { useCallback, useMemo } from 'react'

import { useUser } from '@/context/userContext'

import { BuildPassModule } from 'types/api.graphql'

export const useEnabledModules = () => {
  const { user, aiTools } = useUser() ?? {} // fallback for when using in worker web

  const enabledModules = useMemo(() => {
    if (!user?.adminUser?.modules?.length) return []

    return user.adminUser.modules
  }, [user?.adminUser?.modules])

  const isModuleEnabled = useCallback(
    (module: BuildPassModule) => enabledModules.includes(module),
    [enabledModules]
  )

  const aiModule = {
    // Has the module been turned on
    aiEnabled: isModuleEnabled(BuildPassModule.AiTools),
    // Has the user opted in to AI - accepter terms
    aiOptedIn: aiTools?.aiToolsEnabled,
    // Active features on their account
    aiFeatures: {
      checklistAssistant: aiTools?.checklistAssistantEnabled,
      imageTagging: aiTools?.imageTaggingEnabled,
      siteDiarySummary: aiTools?.siteDiarySummaryEnabled,
      defectEnhancement: aiTools?.defectEnhancementEnabled,
      toolboxSummary: aiTools?.toolboxSummaryEnabled,
      contentTagging: aiTools?.contentTaggingEnabled,
    },
  }

  return {
    enabledModules,
    isModuleEnabled,
    aiModule,
  }
}
